var earn_loyalty_lion_slider = null, redeem_slider = null;
var slider_params = {
  container: null,
  items: 2.4,
  nav: false,
  controls: false,
  gutter: 0,
  center: true,
  startIndex: 0,
  loop: false,
  //edgePadding: -50,
  responsive: {
    577: {
      startIndex: 1,
      items: 4.5,          
    },
    479: {
      items: 3.4,          
    },
  }
};

jQuery(document).ready(function ($) {
  initSlider();
  $(window).resize(function () {
    initSlider();
    initDelayedSlider();
  });
    
  const targetNode = document.getElementById("rules-container"); 
  const config = { attributes: true, childList: true, subtree: true }; 
  const observer = new MutationObserver(initDelayedSlider); 
  observer.observe(targetNode, config);
  
  function initSlider() {
    var $container = $(".ways-to-earn-block");

    if ($container.innerWidth() < 768) {
      if(redeem_slider == null) {
        slider_params.container = $(".redeem-tiles")[0];
        redeem_slider = tns(slider_params);
      } else if(redeem_slider.version == null) {
        redeem_slider = redeem_slider.rebuild();
      } 
    } else {
      if (redeem_slider != null) {
        redeem_slider.destroy();
      }
    }
  }
  
  function initDelayedSlider() {
    console.log('initDelaySlider called');
    var $container = $(".ways-to-earn-block");
    if ($container.innerWidth() < 768) { 
      if(earn_loyalty_lion_slider == null) {
        slider_params.container = $(".ways-to-earn-block .lion-rules-list")[0];
        earn_loyalty_lion_slider = tns(slider_params); 
      } else if(earn_loyalty_lion_slider.version == null) {
        earn_loyalty_lion_slider = earn_loyalty_lion_slider.rebuild(); 
      }  
    } else { 
      if (earn_loyalty_lion_slider != null) {
        earn_loyalty_lion_slider.destroy(); 
      } 
    }
  }
});
